import { makeStyles } from '@material-ui/core/styles';

export const CorreosIconStyles = makeStyles((theme) => ({
    basic: {
        padding: "0.3em",
        margin: "auto 0em",
        '& .icon-path': {
            fill: "#002E6D",
        },
    },
    enabled: {
        padding: "0.3em",
        margin: "auto 0em",
        '& .icon-path': {
            fill: "#333333",
        },
    },
    disabled: {
        padding: "0.3em",
        margin: "auto 0em",
        '& .icon-path': {
            fill: "#CBCBCB",
        },
    },
}));